import { CONFIG } from '../../core/config';
import { PerformanceStandard } from '../performance-standard';
import { ViewModel } from '../view-model';

export class PlannedMaintenanceStandards implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Planned Maintenance Standards';
  readonly apiRoute: string = CONFIG.apiRoutes.plannedMaintenanceLibrary;

  id: string;
  plannedMaintenanceLibraryItemId: string;
  performanceStandardId: string;
  performanceStandard: PerformanceStandard;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.plannedMaintenanceLibraryItemId = data.plannedMaintenanceLibraryItemId;
    this.performanceStandardId = data.performanceStandardId;
    this.performanceStandard = new PerformanceStandard();
    if (data.performanceStandard) {
      this.performanceStandard.loadFromJson(data.performanceStandard);
    }
  }
}
